const isFalsyAndNotZero = (value) => !value && value !== 0

export default isFalsyAndNotZero
